import React, { useState } from 'react'
import { encodeId, slugify } from '../../helper/helperFunction';
import { t } from 'i18next';
import CustomImageComponent from '../../components/CustomImageComponent';
import { useCountryPrefix } from '../../routes/useCountryPrefix';
import { useTranslation } from 'react-i18next';
import NotFoundSec from '../pageNotFound/NotFoundSec';

const DeveloperSec = (props) => {
    const countryPrefix = useCountryPrefix();
    const { i18n } = useTranslation();

    const currentLang = i18n.language === "en" ? "" : i18n.language || "";

    const { data, onLoadMore, loadingMore = false, searchText, setSearchText, searchClicked, clearClicked } = props
    const imageUrl = process.env.REACT_APP_IMAGE_URL;




    return (
        <>
            <section className="company-info-section developer-list-section">
                <div className="container">
                    <div className="search-wrapper">
                        <input
                            id="search"
                            type="search"
                            className="form-control"
                            placeholder={t("search_developer")}
                            autoComplete='off'
                            value={searchText}
                            onChange={(e) => {
                                setSearchText(e.target.value)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault(); // optional but recommended
                                    searchClicked();    // this triggers your search function
                                }
                            }}
                        ></input>

                        <button
                            type="button"
                            className="submit-btn"
                            onClick={() => {
                                searchClicked();
                            }}
                        >
                            {t("search")} <i class="fa-solid fa-magnifying-glass"></i>
                        </button>
                        <button
                            type="button"
                            className="submit-btn clear-btn"
                            onClick={() => {
                                setSearchText("");
                                clearClicked();
                            }}
                        >
                            {t("clear")}
                        </button>



                    </div>
                    {data?.items?.length > 0 ?
                        data?.items?.map((item, index) => (
                            <div className="company-info-wrapper company-info-wrapper-new" key={index}>
                                <div className="row align-items-center">
                                    <div className="col-md-12 col-lg-3">
                                        <div className="img-block">
                                            <CustomImageComponent src={item.thumbnailImage} alt={item.developerName} className={"img-fluid"} />
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-lg-9 ">
                                        <div className="right-part">
                                            <div className="top-block">
                                                <div className="left-block">
                                                    <div className="content-block">
                                                        <h5>{item.developerName || 'N/A'}
                                                            <br></br><span>{item.projectCount} {t("project_available")}</span><span>{item.propertyCount} {t("properties_available")}</span></h5>

                                                    </div>
                                                </div>
                                                <div className="right-block">
                                                    <div>
                                                        <a className="call-btn" href={`tel:${data.contactDetails.phone}`}>
                                                            <CustomImageComponent src={"/assets/img/icon-call.svg"} alt={"Phone"} /> {t("call_us")}
                                                        </a>
                                                        <a className="call-btn whatsapp-btn" href={`https://wa.me/${data.contactDetails.whatsApp}`} target="_blank" rel="noopener noreferrer">
                                                            <CustomImageComponent src={"/assets/img/icon-whatsapp.svg"} alt={"WhatsApp"} /> {t("whatsapp")}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                            <p>{item.description || ''}</p>
                                            {/* <span className="tag">Under Development</span> */}
                                            <div className="text-end">
                                                <a className="view-more" href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/developers/${slugify(item.developerName)}/${encodeId((item.developerId))}`}>{t("view_more")} <i className="fa-solid fa-chevron-right"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )) : (
                            <NotFoundSec title={t("opps")} desc={t("dev_not_found")} img={"/assets/img/not-found.svg"} cssstyle={"p-0"} />
                        )

                    }
                    {data.pageIndex < data.totalPages && (
                        <div className="text-center mt-4 mb-4">
                            <button className="theme-btn theme-btn-secondary" onClick={onLoadMore} disabled={loadingMore}>
                                {loadingMore ? (<i className="fa fa-spinner fa-spin fa-2x ms-0"></i>) : (t("load_more"))}
                            </button>
                        </div>
                    )}
                </div>
            </section>

        </>
    )
}

export default DeveloperSec